export enum OrderTrackingTestEnum {
  ROW = 'tracking-row',
  DETAILS_PANEL = 'tracking-details-panel',
}
